/**
 * Since i18next was replaced in this project, this is instead a solution to be able to use templates.
 * @param translation
 * @param objectData
 */
export const interpolate = (translation: string, objectData: Record<string, string>): string => {
  return Object.entries(objectData).reduce((prev, [objectProperty, objectValue]) => {
    const replaceExpression = new RegExp('({{)[ ]*' + objectProperty + '[ ]*(}})');
    return prev.replace(replaceExpression, objectValue);
  }, translation);
};
